module.exports = __webpack_public_path__ + "static/media/galdisa_banner6.b0938111.jpg";